// extracted by mini-css-extract-plugin
export default {"root":"My_root__teEZS","tabs":"My_tabs__XCnVS","tabItem":"My_tabItem__NMnBF","active":"My_active__7Ibui"};